import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clearStageActualDates } from "@/adapters/api";

export function useClearActualDates(constructionId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (stageId: string) => {
			if (!constructionId) throw new Error("missing construction");
			return clearStageActualDates(constructionId, stageId);
		},
		onSuccess: (_schedule, stageId) => {
			queryClient.invalidateQueries({
				queryKey: ["schedules", constructionId],
			});
			queryClient.invalidateQueries({
				queryKey: ["schedule", constructionId, stageId],
			});
		},
	});
}
